import { useEffect, useState } from "react";
import { safeJSONParse } from "utils/helpers/safeParsing";
import { Alert } from "react-bootstrap";

const ValidateJSON = ({json}) => {
    const [ validate, setValidate ] = useState(true);
    useEffect(()=>{
        try {
            const _json  = JSON.parse(json);
            setValidate(true);
        } catch (error) {
            setValidate(error?.message);
        }
    }, [json])

    return (
        <>
        {validate !== true  && (
            <Alert variant="danger"
                className="mt-2 mb-2">{validate}</Alert>)}
        </> 
    )
}

export default ValidateJSON;